module.exports = __webpack_public_path__ + "static/media/doctorbio.85b4ee48.png";